const TEMPLATES = {
    LANDING_PAGE: {
        RESOURCE_ID: 'templates',
    },
    FORMS: {
        RESOURCE_ID: 'templatesForms',
    },
    POLICIES: {
        RESOURCE_ID: 'templatesSamplePolicies',
    },
    LETTERS: {
        RESOURCE_ID: 'templatesLetters',
    },
    TOOLKITS: {
        RESOURCE_ID: 'templatesToolkits',
    },
    BENEFITS: {
        RESOURCE_ID: 'templatesBenefits',
    },
    DISCRIMINATION_AND_EQUAL_EMPLOYMENT: {
        RESOURCE_ID: 'templatesDiscriminationEqualEmployment',
    },
    HIRING: {
        RESOURCE_ID: 'templatesHiring',
    },
    LEAVES_AND_TIME_OFF: {
        RESOURCE_ID: 'templatesLeavesTimeOff',
    },
    MANAGING_EMPLOYEES: {
        RESOURCE_ID: 'templatesManagingEmployees',
    },
    SAFETY_AND_HEALTH: {
        RESOURCE_ID: 'templatesSafetyHealth',
    },
    TERMINATION: {
        RESOURCE_ID: 'templatesTermination',
    },
    WAGE_AND_HOUR: {
        RESOURCE_ID: 'templatesWagehour',
    },
};

export default TEMPLATES;
